import Definition from "../../components/Definition/Definition";

const DefinitionPage: React.FC = () => {
  return <Definition />;
};

export default DefinitionPage;
